export default __webpack_public_path__ + "static/media/750.727aac12.png";